export default __webpack_public_path__ + "static/media/tavi_small.70071abd.jpg";